import type { FC } from 'react';
import { AlertCircleFilled } from '@eqi-investimentos/icons/web';
import { Box, Flex } from '@eqi-investimentos/react';

export const BadgeErrorForm: FC<BadgeErrorFormProps> = ({ htmlError }) => (
  <Flex
    data-testid="badge-error-form"
    alignItems="center"
    p="m"
    gap="s"
    w="full"
    bgColor="background.brandLight"
    borderRadius="xs"
    transition="all 300ms ease-in-out"
  >
    <AlertCircleFilled color="content.brand" w={24} h={24} />
    <Box
      sx={{
        p: {
          fontSize: 'l',
          color: 'content.primary',
        },
      }}
      dangerouslySetInnerHTML={{ __html: htmlError }}
    />
  </Flex>
);

type BadgeErrorFormProps = {
  htmlError: string;
};
